import React from "react";
import { Field } from "formik";
interface FormikFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  placeholder?: string;
  row?: number;
}
const EditorTextArea = ({
  name,
  label,
  placeholder,
  row,
  ...props
}: FormikFieldProps) => {
  return (
    <div className="mb-4 poppins-regular jost-regular">
      {label && (
        <label
          htmlFor={name}
          className="block mb-2 text-sm font-medium opacity-50 font-montserrat"
        >
          {label}
        </label>
      )}
      <Field
        id={name}
        name={name}
        as="textarea"
        rows={row}
        placeholder={placeholder}
        className="w-full px-4 py-3 border-b bg-transparent placeholder:text-white placeholder:opacity-50 shadow-sm font-montserrat focus:ring-0 active:ring-0 focus:outline-none focus:ring-blue-500"
        {...props}
      />
    </div>
  );
};
export default EditorTextArea;
